export default __webpack_public_path__ + "static/karthik-srinivasan-60f4a572066ab08ef662ebf4b7e6507c.png";